import { isMobile } from './is-mobile';
import { getConfig } from '../core/userway';
import { Position } from '../core/widget-position';

const MAX_MOVE_DESKTOP = 498;
const MAX_MOVE_MOBILE = 432;
const DEFAULT_MINI_POSITION = 3;

export const getMiniMoveY = (): number => {
  const widgetPositionNudgeMobile =
    getConfig()?.tunings?.widget_position_nudge_mobile;
  const widgetPositionNudge = getConfig()?.tunings?.widget_position_nudge;

  if (!widgetPositionNudgeMobile || !widgetPositionNudge) return 0;

  const { moveY = 0, yOrientation = '' } = isMobile()
    ? getConfig()?.tunings?.widget_position_nudge_mobile
    : getConfig()?.tunings?.widget_position_nudge;

  if (!moveY || !yOrientation) return 0;

  const miniWidgetPosition =
    parseInt(
      isMobile()
        ? getConfig()?.tunings?.widget_position_mobile
        : getConfig()?.tunings?.widget_position,
      10,
    ) || DEFAULT_MINI_POSITION;

  const maxMove = isMobile() ? MAX_MOVE_MOBILE : MAX_MOVE_DESKTOP;

  const bottomPositions = [
    Position.LeftBottom,
    Position.RightBottom,
    Position.MiddleBottom,
  ];
  const topPositions = [
    Position.LeftTop,
    Position.RightTop,
    Position.MiddleTop,
  ];
  const middlePositions = [Position.LeftMiddle, Position.RightMiddle];

  let initialPosition = '';

  if (bottomPositions.includes(miniWidgetPosition)) {
    initialPosition = 'bottom';
  } else if (topPositions.includes(miniWidgetPosition)) {
    initialPosition = 'top';
  } else if (middlePositions.includes(miniWidgetPosition)) {
    initialPosition = 'middle';
  }

  let translateY = 0;
  let resultMoveY = 0;
  switch (initialPosition) {
    case 'top':
      resultMoveY = moveY > maxMove ? maxMove : moveY;
      translateY = yOrientation === 'top' ? resultMoveY : 0;
      break;
    case 'bottom':
      resultMoveY = moveY > maxMove ? maxMove : moveY;
      translateY = yOrientation === 'top' ? 0 : -resultMoveY;
      break;
    case 'middle':
      resultMoveY = moveY > maxMove / 2 ? maxMove / 2 : moveY;
      translateY = yOrientation === 'top' ? resultMoveY : -resultMoveY;
      break;
  }

  return translateY;
};
